<template>
    <div class="modal fade" id="forecastInfoModal" tabindex="-1" role="dialog" aria-labelledby="forecastInfoTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="forecastInfoTitle">Forecast</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul v-if="$store.state.forecast != null" class="list-group">
                        <li class="list-group-item">Forecast ID: {{ $store.state.forecast.forecastID.toString(true) }}</li>
                        <li class="list-group-item">Country/area: {{ $store.state.forecast.country.name }}</li>
                        <li class="list-group-item">Published: {{ $store.state.forecast.pubDate.toDateString() }}</li>
                    </ul>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from '@/lib/JQuery.js'

export default {
    name: 'ForecastInfoDialog',
    methods: {
        show() {
            $(this.$refs.modal).modal('show')
        }
    }
}
</script>

<style>

</style>
